import React, { Component } from 'react';
import { Growl } from 'primereact/growl';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Message } from 'primereact/message';

import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioPaginacion from '../servicios/ServicioPaginacion';
import servicioPlazacobro from '../servicios/servicioPlazaCobro';
import servicioEmisor from '../servicios/ServicioEmisor';

class PlazaCobro extends Component {
  constructor() {
    super();
    this.state = {
      paginacion: {
        registrosPorPagina: 20,
        clase: 'com.mx.quadrum.banobras.facturacion.web.guadalara.colima.backend.entidad.fbanobrasgc.TcPlazaCobro',
        join: [],
        conjunciones: {}
      },
      first: 0,
      plazacobro: {},
      errores: {},
      estado: null,
      emisor: null,
      listaEmisores: [],
      estados: [
        { name: 'Activo', code: 1 },
        { name: 'Inactivo', code: 0 }
      ]

    };
  }

  componentDidMount() {
    this.obtenerResultados();
    this.obtenerEmisores();
  }

  obtenerResultados = () => {
    const { paginacion } = this.state;
    servicioPaginacion.paginacionGeneral(paginacion).then((response) => {
      this.setState({ paginacion: response.data });
    });
  }

  obtenerEmisores = () => {
    servicioEmisor.buscarEmisores().then(response => {
      this.setState({ listaEmisores: response.data });
    }).catch(error => {

    });
  }



  onPage = (event) => {
    this.setState({
      first: event.first
    });
    const { paginacion } = this.state;
    paginacion.numeroPagina = event.page;
    paginacion.registrosPorPagina = event.rows;
    servicioPaginacion.paginacionGeneral(paginacion).then((response) => {
      this.setState({ paginacion: response.data });
    });
  }

  asignarValoresObjeto = (event) => {
    servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);

  }

  formatoEstado = (rowData, column) => {
    let estado = rowData.estado;
    let valor = "";
    switch (estado) {
      case 0:
        valor = "Inactivo";
        break;
      case 1:
        valor = "Activo";
        break;
      default:
        valor = "E";
    }
    return <div>
      {valor}
    </div>;
  }

  validarFormulario = (plazacobro, estado, emisor) => {
    const errores = {};
    if (!plazacobro.nombre)
      errores.nombre = "El nombre es requerido";
    if (!plazacobro.numero)
      errores.numero = "El numero es requerido";
    if (!estado)
      errores.estado = "El estado es requerido";
    if (!emisor)
      errores.emisor = "El emisor es requerido";
    return errores;
  }

  estadosCambios = (e) => {
    this.setState({ estado: e.value });

  }

  cambiosEmisor = (e) => {
    this.setState({ emisor: e.value });

  }

  buscarPlaza = () => {
    const { plazacobro } = this.state;
    servicioPlazacobro.buscarPlaza(plazacobro).then(response => {
      if (response.data) {
        this.growl.show({ life: 5000, severity: 'error', summary: 'Mensaje de error', detail: 'El numero ' + plazacobro.numero + ' ya se encuentra registrado' });
        this.setState({ plazacobro: { ...this.plazacobro, nombre: '' } });
      }
    }).catch(error => {

    });
  }


  guardar = () => {
    const { plazacobro, estado, emisor } = this.state;
    const validacion = this.validarFormulario(plazacobro, estado, emisor);
    this.setState({ errores: validacion });
    if (!Object.keys(validacion).length) {
      plazacobro['estado'] = estado.code;
      plazacobro['tcEmisor'] = emisor;
      servicioPlazacobro.guardar(plazacobro).then(response => {
        this.setState({ plazacobro: {}, estado: null, emisor: null });
        this.growl.show({ severity: 'success', summary: 'Exito', detail: 'La plaza de cobro se creo con exito' });
        this.obtenerResultados();
      }).catch(error => {
        this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'Existe un error con la conexion al servidor' });
      });
    }
  }

  actionOpciones = (rowData, column) => {
    return <div>
      <Button type="button" icon="pi pi-pencil" className="p-button-success"
        onClick={this.preeditar.bind(this, column.rowData)} value={rowData.id} name="objeto" tooltip="Editar">
      </Button>
      <Button type="button" icon="pi pi-trash" className="p-button-danger"
        onClick={(e) => this.onBorrar(column.rowIndex, rowData)} value={rowData.id} name="id" tooltip="Eliminar" >
      </Button>
    </div>;
  }

  preeditar = (objeto, rowdata) => {
    const { estados } = this.state;

    var estado = estados.filter(obj => {
      return obj.code === objeto.estado;
    });
    this.setState({
      plazacobro: objeto,
      estado: estado[0]
    });
  }

  onBorrar = (fila, datos) => {
    console.log(datos);
    servicioPlazacobro.eliminar({ id: datos.id }).then(response => {
      this.setState({ plazacobro: {}, estado: null, emisor: null });
      this.growl.show({ severity: 'success', summary: 'Exito', detail: 'La plaza de cobro se elimino con exito' });
      this.obtenerResultados();
    }).catch(error => {
      this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'Existe un error con la conexion al servidor' });
    })
  }


  render() {

    const { plazacobro, errores, paginacion, first, listaEmisores, estados } = this.state;



    return (
      <div className="card card-w-title">
        <Growl ref={(el) => this.growl = el} />
        <h1>Administración de Plaza de cobro</h1>
        <h4>Los campos con (*) son obligatorios</h4>
        <div className="p-grid p-fluid">
          <div className="p-col-12 p-md-4">
            <h4>*Nombre:</h4>
            <InputText id="nombre" name="plazacobro.nombre" value={plazacobro.nombre || ''} onChange={this.asignarValoresObjeto} className={errores.nombre ? 'p-error' : ''} onBlur={this.buscarEmisor} />
            {errores.nombre ? <div><br /> <Message severity="error" text={errores.nombre} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-4">
            <h4>*Número:</h4>
            <InputText id="numero" name="plazacobro.numero" value={plazacobro.numero || ''} onChange={this.asignarValoresObjeto} className={errores.numero ? 'p-error' : ''} onBlur={this.buscarPlaza} />
            {errores.numero ? <div><br /> <Message severity="error" text={errores.numero} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-4">
            <h4>*Estado:</h4>
            <Dropdown value={this.state.estado} options={estados} className={errores.estado ? 'p-error' : ''} onChange={this.estadosCambios} placeholder="Selecciona estatus" optionLabel="name" autoWidth={false} />
            {errores.estado ? <div><br /> <Message severity="error" text={errores.estado} /> </div> : null}
          </div>
        </div>
        <div className="p-grid p-fluid">
          <div className="p-col-12 p-md-4">
            <h4>*Emisor:</h4>
            <Dropdown value={this.state.emisor} options={listaEmisores} className={errores.emisor ? 'p-error' : ''} onChange={this.cambiosEmisor} placeholder="Selecciona emisor" optionLabel="nombre" autoWidth={false} />
            {errores.emisor ? <div><br /> <Message severity="error" text={errores.emisor} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-4 p-offset-4">
            <br /> <br /> <br />
            <Button label="Guardar" className="p-button-rounded p-button-warning" onClick={this.guardar} />
          </div>
        </div>
        <Card>
          <DataTable value={paginacion.datos} editable={true} selectionMode="single" scrollable={true} scrollHeight="220px"  >
            <Column field="nombre" header="Nombre" style={{ width: '200px' }} filter={false} autoLayout={true} />
            <Column field="numero" header="Número" style={{ width: '200px' }} filter={false} autoLayout={true} />
            <Column body={this.formatoEstado} header="Estado Plaza de Cobro" style={{ width: '110px' }} />
            <Column header="Opciones" body={this.actionOpciones} style={{ textAlign: 'center', width: '12em' }} />
          </DataTable>
          <Paginator totalRecords={paginacion.registrosTotales} rows={paginacion.registrosPorPagina} first={first} onPageChange={this.onPage} rowsPerPageOptions={[20, 40, 60, 80, 100]}></Paginator>
        </Card>
      </div>
    );
  }

}
export default PlazaCobro;